import { VERSION } from "utils/constants";

/* Rodapé fixo com a versão — sempre visível em qualquer tela, útil para
   confirmar qual deploy o navegador está vendo (mesmo padrão do app moai). */
export function AppVersion() {
  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        bottom: 6,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        zIndex: 50,
        pointerEvents: "none",
      }}
    >
      <span
        style={{
          fontSize: 10,
          lineHeight: "14px",
          letterSpacing: 0.4,
          color: "rgba(255, 255, 255, 0.75)",
          background: "rgba(0, 0, 0, 0.45)",
          borderRadius: 6,
          padding: "0 6px",
        }}
      >
        {VERSION}
      </span>
    </div>
  );
}
